export const initialCountry = {
  id: 'GB',
  label: 'United Kingdom',
};

export const initialAddress: Address = {
  name: '',
  line1: '',
  line2: '',
  town: '',
  county: '',
  postcode: '',
  country: initialCountry.id,
  domestic_id: '',
};
